import { DEFAULT_AGENT_META, DEFAULT_INBOX_AVATAR } from '@/const/meta';
import { SilverTigerAgentSession, ConversationType } from '@/types_cp/session';
import { merge } from '@/utils_cp/merge';

export const INBOX_CONVERSATION_ID = 'inbox';

export const WELCOME_GUIDE_CHAT_ID = 'welcome';

export const DEFAULT_AGENT_SILVERTIGER_SESSION: SilverTigerAgentSession = {
  config: {},
  createdAt: new Date(),
  id: '',
  meta: DEFAULT_AGENT_META,
  type: ConversationType.Agent,
  updatedAt: new Date(),
};

export const DEFAULT_INBOX_SESSION: SilverTigerAgentSession = merge(DEFAULT_AGENT_SILVERTIGER_SESSION, {
  id: 'inbox',
  meta: {
    avatar: DEFAULT_INBOX_AVATAR,
  },
});
